const getBrandedFooterLimit = (rootState) => rootState.ws.integration.settings.limits.brandedFooter;

export default getBrandedFooterLimit;
